import Validators from '../validators'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => store.createEmbededEntityState({
  attrs: ['movie', 'pricings', 'valid_from', 'valid_to'],
  initVals: (row) => ({ id: null }),
  validators: {
    movie: Validators.isMandatory(store),
    valid_from: [
      Validators.isValidFromTo(store)
    ],
    valid_to: [
      Validators.isValidFromTo(store)
    ],
    _global: oVals => {
      const movie = oVals.get('movie')
      if (movie && movie !== oVals.get('fetchedMovie')) {
        store.requester.call(`/films/${movie}`, 'get').then(({ data }) => {
          oVals.set('fetchedMovie', data.id)
          oVals.set('pricings', [...data.flyprivate_video_pricing].filter(d => !moment(d.valid_to).isBefore(moment())))
          oVals.set('selection', [...data.flyprivate_video_pricing].filter(d => !moment(d.valid_to).isBefore(moment())).map(c => c.id))
        })
      }

      const error = []

      const values = oVals.get('pricings') ? oVals.get('pricings').filter(v => oVals.get('selection').find(id => id === v.id)) : []

      for (const vals of values) {
        if (!vals.has) {
          vals.has = (k) => vals[k] || false
          vals.get = (k) => vals[k] || null
          vals.set = (k, v) => { vals[k] = v }
        }

        const flyprivatePricingTier = vals.has('flyprivate_platform_tier_pricing_id') && vals.get('flyprivate_platform_tier_pricing_id')
          ? store.options.get('flyprivate_pricings').find(i => i.id === vals.get('flyprivate_platform_tier_pricing_id'))
          : null

        if (!vals.has('pricing_select_platform') && flyprivatePricingTier) {
          vals.set('pricing_select_platform', flyprivatePricingTier.platform)
          vals.set('pricing_select_type', flyprivatePricingTier.type_sale)
          vals.set('pricing_select_tier', flyprivatePricingTier.tier)
        }

        // pricing tier filters
        if (!vals.has('pricing_select_platform') || !vals.get('pricing_select_platform')) {
          vals.set('pricing_select_type', '')
          vals.set('pricing_select_tier', '')
          vals.set('flyprivate_platform_tier_pricing_id', null)
        }
        if (!vals.has('pricing_select_type') || !vals.get('pricing_select_type')) {
          vals.set('pricing_select_tier', '')
          vals.set('flyprivate_platform_tier_pricing_id', null)
        }
        if (!vals.has('pricing_select_tier') || !vals.get('pricing_select_tier')) {
          vals.set('flyprivate_platform_tier_pricing_id', null)
        }

        // set flyprivate_platform_tier_pricing_id if all parametrs are selected
        if (flyprivatePricingTier || (vals.has('pricing_select_platform') && vals.get('pricing_select_platform') &&
          vals.has('pricing_select_type') && vals.get('pricing_select_type') &&
          vals.has('pricing_select_tier') && vals.get('pricing_select_tier'))
        ) {
          const found = store.options.get('flyprivate_pricings').find(i =>
            i.platform === vals.get('pricing_select_platform') &&
            i.type_sale === vals.get('pricing_select_type') &&
            i.tier === vals.get('pricing_select_tier')
          )
          vals.set('flyprivate_platform_tier_pricing_id', found ? found.id : null)
          if (found) {
            vals.set('pricing_select_platform', found.platform)
            vals.set('pricing_select_type', found.type_sale)
            vals.set('pricing_select_tier', found.tier)
          }
        }

        // global Pricing ID validation
        if (!vals.has('flyprivate_platform_tier_pricing_id') || !vals.get('flyprivate_platform_tier_pricing_id')) {
          return store.__('Pricing ID is mandatory')
        }

        // overlapping stuff
        const isOverlapping = (cStart, cEnd, nStart, nEnd) => {
          const cRange = cStart && cEnd && moment.range(cStart, cEnd)
          const nRange = nStart && nEnd && moment.range(nStart, nEnd)
          return cRange.overlaps(nRange) || nRange.overlaps(cRange) ||
            moment(cStart).format('YYYY-MM-DD') === moment(nEnd).format('YYYY-MM-DD') ||
            moment(nStart).format('YYYY-MM-DD') === moment(cEnd).format('YYYY-MM-DD')
        }

        const countries = store.options.get('Countries')
        const getRegions = (regions) => {
          if (!regions || !regions.length) {
            return ['']
          } else if (regions === 'WW') {
            return ['WW']
          }
          const splitRegions = (regions.charAt(0) === '-' ? regions.substring(1) : regions).split(',')
          return regions.charAt(0) === '-'
            ? countries.map(country => !splitRegions
              .find(region => region === country.value) && country.value)
              .filter(result => result && result.length <= 2)
            : splitRegions
        }
        const regions = vals.get('regions') && vals.get('regions').length > 0 ? getRegions(vals.get('regions')) : ['']
        const noOverlap = ['EST', 'TVOD']
        const getItem = id => store.options.get('flyprivate_pricings').find(p => p.id === id && p.currency_cd)
        const isTypeSale = (type, id) => store.options.get('flyprivate_pricings').find(p => p.id === id && p.type_sale === type)

        regions.forEach(reg => {
          if (values && values.some(p =>
            ((reg === '' && !p.regions) ||
              (reg !== '' && p.regions && p.regions.length > 0 && (getRegions(p.regions).find(r => r === reg)))) &&
            vals.get('flyprivate_platform_tier_pricing_id') === p.flyprivate_platform_tier_pricing_id &&
            !isTypeSale('EST', p.flyprivate_platform_tier_pricing_id) &&
            !isTypeSale('TVOD', p.flyprivate_platform_tier_pricing_id) &&
            ((typeof p.id === 'undefined' && vals.has('id')) ||
              (p.id && p.id !== vals.get('id')) &&
            isOverlapping(
              oVals.get('valid_from') || moment(vals.get('valid_from')).isBefore(moment()) ? new Date() : vals.get('valid_from'),
              new Date(vals.get('valid_to')),
              new Date(p.valid_from),
              new Date(p.valid_to)
            )))) {
            error.push(store.__('Duplicate pricing. ') +
              (!reg ? '' : store.__('For region: ') + reg.concat('. '))
            )
          }
        })

        regions.forEach(reg => {
          noOverlap.map(typeSale => {
            if (values && isTypeSale(typeSale, vals.get('flyprivate_platform_tier_pricing_id'))) {
              const errorValue = values.find(p =>
                ((reg === '' && !p.regions) ||
                  (reg !== '' && p.regions && p.regions.length > 0 && (getRegions(p.regions).find(r => r === reg)))) &&
                isTypeSale(typeSale, p.flyprivate_platform_tier_pricing_id) &&
                (getItem(vals.get('flyprivate_platform_tier_pricing_id')).platform ===
                  getItem(p.flyprivate_platform_tier_pricing_id).platform) &&
                ((typeof p.id === 'undefined' && vals.has('id')) ||
                  (p.id && p.id !== vals.get('id')) && isOverlapping(
                    oVals.get('valid_from') || moment(vals.get('valid_from')).isBefore(moment()) ? new Date() : vals.get('valid_from'),
                    new Date(vals.get('valid_to')),
                    new Date(p.valid_from), new Date(p.valid_to)
                  )))
              if (errorValue) {
                error.push(
                  typeSale.concat(' ') +
                  store.__('can\'t overlap. The collision items are: ') +
                  (vals.has('id') ? (' ID ' + vals.get('id')) : store.__(' new item ')) +
                  store.__(' & ') +
                  (typeof errorValue.id !== 'undefined' ? (' ID ' + errorValue.id) : store.__(' new item ')) +
                  '. '
                )
              }
            }
          })
        })

        const mobi = vals.get('quality_mobile')
        const sd = vals.get('quality_sd')
        const hd = vals.get('quality_hd')
        const uhd = vals.get('quality_uhd')
        if (!(mobi || sd || hd || uhd)) {
          error.push(store.__('Check at least one quality, please. '))
        }
      }

      return error.length > 0 ? error : undefined
    }
  }
})
